import { useQuery } from "@tanstack/react-query";
import apiClient from "../../api-client.js";

export const getData = (
  endpoint,
  shouldGetData,
  refresh = 0,
  withCredentials = true // Restaurado a true como en el sistema anterior
) => {

  const { data, error, isError, isLoading, isFetching, isInitialLoading } = useQuery({
    queryKey: ["getData", endpoint, refresh],
    queryFn: () => {
      return apiClient
        .get(endpoint, {
          withCredentials, // usa el valor del parámetro
        })
        .then((res) => {
        
          return res.data;
        })
        .catch((err) => {
          
          throw err;
        });
    },
    enabled: shouldGetData,
  });

  return { data, error, isError, isLoading, isFetching, isInitialLoading };

};